<div class="flex flex-col justify-center items-center min-h-screen bg-background">
  <div class="flex bg-white shadow-lg rounded-2xl overflow-hidden max-w-md w-full">
    <div class="w-full px-8 py-10 text-center">
      <img [src]="branding.LOGO" [alt]="branding.APP_NAME" class="h-9 mb-2 mx-auto" />
      <h1 class="text-2xl font-bold mb-2 text-primary-dark">Alterar Senha</h1>
      <p class="font-normal mb-10 text-primary-gray">
        Informe a senha atual e a nova senha que deseja utilizar.
      </p>
       <form [formGroup]="alterarSenhaForm">
      <div class="mb-4 text-left">
        <label for="senhaAtual" class="input-label">
          Senha Atual
        </label>
        <div class="input-field"
          [ngClass]="{'input-field-error': alterarSenhaForm.get('senhaAtual')?.invalid && !senhaAtualFocused && alterarSenhaForm.get('senhaAtual')?.touched && alterarSenhaForm.get('senhaAtual')?.value, 'input-field-focus': !(alterarSenhaForm.get('senhaAtual')?.invalid && !senhaAtualFocused && alterarSenhaForm.get('senhaAtual')?.touched && alterarSenhaForm.get('senhaAtual')?.value)}">
          <mat-icon fontSet="material-icons-outlined" class="text-gray-500 small-icon">lock</mat-icon>
          <input id="senhaAtual" [type]="passwordVisible ? 'text' : 'password'" formControlName="senhaAtual"
            placeholder="Insira sua senha atual" class="input-element py-3" (focus)="senhaAtualFocused = true"
            (blur)="senhaAtualFocused = false" />
          <button type="button" class="button-standard button-color-primary" (mousedown)="$event.preventDefault();"
            (click)="this.passwordVisible = !this.passwordVisible" class="px-2 focus:outline-none">
            <mat-icon fontSet="material-icons-outlined" class="text-gray-500 small-icon">{{ passwordVisible ? 'visibility_off' : 'visibility'
              }}</mat-icon>
          </button>
        </div>
      </div>
      <div class="mb-4 text-left">
        <label for="novaSenha" class="input-label">
          Nova senha
        </label>
        <div class="input-field"
          [ngClass]="{'input-field-error': alterarSenhaForm.get('novaSenha')?.invalid && !novaSenhaFocused && alterarSenhaForm.get('novaSenha')?.touched && alterarSenhaForm.get('novaSenha')?.value, 'input-field-focus': !(alterarSenhaForm.get('novaSenha')?.invalid && !novaSenhaFocused && alterarSenhaForm.get('novaSenha')?.touched && alterarSenhaForm.get('novaSenha')?.value)}">
          <mat-icon fontSet="material-icons-outlined" class="text-gray-500 small-icon">lock</mat-icon>
          <input id="novaSenha" [type]="newpasswordVisible ? 'text' : 'password'" formControlName="novaSenha"
            placeholder="Insira sua nova senha" class="input-element py-3" (focus)="novaSenhaFocused = true"
            (blur)="novaSenhaFocused = false" />
          <button type="button" class="button-standard button-color-primary" (mousedown)="$event.preventDefault();"
            (click)="this.newpasswordVisible = !this.newpasswordVisible" class="px-2 focus:outline-none">
            <mat-icon fontSet="material-icons-outlined" class="text-gray-500 small-icon">{{ newpasswordVisible ? 'visibility_off' : 'visibility'
              }}</mat-icon>
          </button>
        </div>
        <div
          *ngIf="alterarSenhaForm.get('novaSenha')?.invalid && !novaSenhaFocused && alterarSenhaForm.get('novaSenha')?.touched && alterarSenhaForm.get('novaSenha')?.value"
          class="text-red-500 text-sm mt-1">
          <div *ngIf="alterarSenhaForm.get('novaSenha')?.errors?.['required']">
            Senha é obrigatória.
          </div>
          <div *ngIf="alterarSenhaForm.get('novaSenha')?.errors?.['minlength']">
            Senha deve ter pelo menos 8 caracteres.
          </div>
          <div *ngIf="alterarSenhaForm.get('novaSenha')?.errors?.['pattern']">
            Senha deve conter letras maiúsculas, minúsculas e caracteres especiais.
          </div>
        </div>
      </div>
      <div class="mb-4 text-left">
        <label for="confirmeSenha" class="input-label">
          Confirme a nova senha
        </label>
        <div class="input-field"
          [ngClass]="{'input-field-error': alterarSenhaForm.get('confirmeSenha')?.invalid && !confirmeSenhaFocused && alterarSenhaForm.get('confirmeSenha')?.touched && alterarSenhaForm.get('confirmeSenha')?.value, 'input-field-focus': !(alterarSenhaForm.get('confirmeSenha')?.invalid && !confirmeSenhaFocused && alterarSenhaForm.get('confirmeSenha')?.touched && alterarSenhaForm.get('confirmeSenha')?.value)}">
          <mat-icon fontSet="material-icons-outlined" class="text-gray-500 small-icon">lock</mat-icon>
          <input id="confirmeSenha" [type]="confirmationPasswordVisible ? 'text' : 'password'"
            formControlName="confirmeSenha" placeholder="Repita a nova senha" class="input-element py-3"
            (focus)="confirmeSenhaFocused = true" (blur)="confirmeSenhaFocused = false" />
          <button type="button" class="button-standard button-color-primary"
            (click)="this.confirmationPasswordVisible = !this.confirmationPasswordVisible"
            class="px-2 focus:outline-none">
            <mat-icon fontSet="material-icons-outlined" class="text-gray-500 small-icon">
              {{ confirmationPasswordVisible ? 'visibility_off' : 'visibility' }}
            </mat-icon>
          </button>
        </div>
        <div
          *ngIf="alterarSenhaForm.get('confirmeSenha')?.invalid && !confirmeSenhaFocused && alterarSenhaForm.get('confirmeSenha')?.touched && alterarSenhaForm.get('confirmeSenha')?.value"
          class="text-red-500 text-sm mt-1">
          <div *ngIf="alterarSenhaForm.get('confirmeSenha')?.errors?.['required']">
            Confirmação de senha é obrigatória.
          </div>
          <div *ngIf="alterarSenhaForm.get('confirmeSenha')?.errors?.['mismatch']">
            As senhas não coincidem.
          </div>
        </div>
      </div>
      <button type="submit" class="button-standard button-color-primary mb-4"
        [ngClass]="{'button-disabled': alterarSenhaForm.invalid}" [disabled]="alterarSenhaForm.invalid"
        (click)="onSubmit()">
        Alterar Senha
      </button>
      <app-voltar-indicator (navigateBack)="navigateBack()" />
    </form>
    </div>
  </div>
</div>
